/**
 * ControlPanel — the bordered white container that holds the report's
 * controls (pinned axes, the collapsible filters, the scope chips) under
 * the ReportHeader (nuevo look Omnitok, iteración 2). It replaces the
 * navy gradient card the filter surfaces used to sit in: on this
 * surface the filter components render their ``surface="light"``
 * variant.
 *
 * Presentation only; the host decides what goes inside.
 */
import type { ReactNode } from "react";

export interface ControlPanelProps {
  children: ReactNode;
  className?: string;
}

export function ControlPanel({ children, className }: ControlPanelProps): JSX.Element {
  return (
    <div
      data-control-panel=""
      className={`rounded-[14px] border border-neutral-200 bg-white px-4 py-2.5 shadow-sm ${className ?? ""}`}
    >
      {children}
    </div>
  );
}
